import { NgModule } from '@angular/core';
import { FormatNumberValuesPipe } from './format-number-values.pipe';

@NgModule({
    declarations: [FormatNumberValuesPipe],
    exports: [FormatNumberValuesPipe]
})
export class FormatNumberValuesModule {}
